var $ = require('../internals/export');
var ownKeys = require('../internals/own-keys');

// `Reflect.ownKeys` method
// https://tc39.github.io/ecma262/#sec-reflect.ownkeys
$({ target: 'Reflect', stat: true }, {
  ownKeys: ownKeys
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.reflect.own-keys.js
// module id = 860
// module chunks = 3